import React from 'react';
import NumberFormat, { NumberFormatValues } from 'react-number-format';
import dayjs from 'dayjs';
import 'styles/date-input.scss';
import { useState } from 'react';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

interface IDateTypedInputProps {
    className: string;
    id: string;
    name: string;
    value: Date | undefined;
    onChange: (value: string, shouldUpdate?: boolean) => void;
    disabled: boolean;
}

const DateTypedInput = (props: IDateTypedInputProps): JSX.Element => {
    const [dateValue, setDateValue] = useState(dayjs(props?.value).format('MM/DD/YYYY'));
    const [dateValid, setDateValid] = useState(true);

    const changeHandler = (input: string): void => {
        if (!input) {
            return null;
        }

        const formattedDay = dayjs(input).format('YYYY-MM-DD');

        props.onChange(formattedDay);
    };

    return (
        <NumberFormat
            id={props.id}
            name={props.name}
            className={`form-control-sm form-control rounded-0 ${props.className} ${
                dateValid ? '' : 'border-bottom border-danger'
            }`}
            format={'##/##/####'}
            disabled={props.disabled}
            value={dateValue}
            onValueChange={(value: NumberFormatValues) => {
                setDateValue(value.value);
                setDateValid(dayjs(value.value, 'MMDDYYYY', true).isValid());
            }}
            onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                changeHandler(e.target.value);
            }}
        />
    );
};

export default DateTypedInput;
